import { apiUrl, gitHash, sgwUrl, version } from '~/constants/environment';

import { createKyInstance } from '@vestigas/data';

import { currentLocale } from '~/utils/i18n';
import { log } from '~/utils/logging';

import AuthService from './auth.service';

export { HTTPError, isAbortError } from '@vestigas/data';

/**
 * ky instance for working with the VESTIGAS API in the current environment.
 */
export const vestigasApi = createKyInstance({
  authService: AuthService,
  baseUrl: apiUrl,
  extraHeaders: {
    'Customer-Portal-Version-Git': gitHash ?? 'local-dev',
    'Customer-Portal-Version-Semantic': version,
  },
  localeProvider: currentLocale,
  logger: log,
  withCaseConverter: true,
});

/**
 * ky instance for the VESTIGAS API without automatic case conversion.
 * Used when request/response contains user-defined keys that should not be transformed.
 */
export const vestigasApiNoConversion = createKyInstance({
  authService: AuthService,
  baseUrl: apiUrl,
  extraHeaders: {
    'Customer-Portal-Version-Git': gitHash ?? 'local-dev',
    'Customer-Portal-Version-Semantic': version,
  },
  localeProvider: currentLocale,
  logger: log,
  withCaseConverter: false,
});

/**
 * ky instance for working with the VESTIGAS sync gateway in the current environment.
 */
export const vestigasSyncGateway = createKyInstance({
  authService: AuthService,
  baseUrl: sgwUrl,
  localeProvider: currentLocale,
  logger: log,
  useIdToken: true,
  withCaseConverter: true,
});

/**
 * ky instance for public VESTIGAS API endpoints that don't require authentication.
 * Used for magic link endpoints and other public access routes.
 *
 * NO `logger` — the only instance in either app without one. Both of the
 * client's reporting paths are gated on it, so on this instance a
 * `validate.response` schema validates and substitutes the body but reports no
 * drift, and a request-validation failure never reaches `logger.error`. Silent
 * by omission rather than by decision: adding `logger: log` is one line, but it
 * would start reporting for the public routes that already declare `validate`,
 * which is a change to make deliberately and not as a side effect.
 */
export const vestigasPublicApi = createKyInstance({
  authService: null,
  baseUrl: apiUrl,
  localeProvider: currentLocale,
  withCaseConverter: true,
});
